export function getImageThumbnailUrl(media) {
  const { model, imageNameThumb, imageThumb } = media
  const { imageName: modelImageName } = model ?? {}
  const { thumb } = modelImageName ?? {}
  const { url: thumbnailUrl } = thumb ?? {}

  return thumbnailUrl || imageNameThumb || imageThumb
}
